// Copyright (c) 2022 by Move Closer

import { ThemeRegistry } from '../../composables'

import { ListOrientation, ListStyle } from './List.contracts'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const orientationClassRegistry: ThemeRegistry<ListOrientation> = {
  [ListOrientation.Horizontal]: '--horizontal',
  [ListOrientation.Vertical]: ''
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const pointerClassRegistry: ThemeRegistry<ListStyle> = {
  [ListStyle.Boxed]: '--boxed',
  [ListStyle.NoPointer]: '--no-pointer',
  [ListStyle.Ordered]: '',
  [ListStyle.UnOrdered]: ''
}
